import { FormSchema } from "../../../interfaces/components/form";
import { FormComponent } from "../../utils/enums";
import { mockInventory } from "../../../api/pharmacy/mock-data/inventory";

const dosageOptions = mockInventory.map((item) => ({
  label: item.dosageForms,
  value: item.dosageForms,
}));

export const addNewMedication: FormSchema = {
  type: "object",
  properties: {
    name: {
      label: "Medication Name",
      type: "text",
      required: true,
      component: FormComponent.Input,
      helperText: "Enter the full name of the medication as prescribed",
      componentProps: {
        placeholder: "Enter medication name",
        type: "text",
      },
    },
    dosage: {
      label: "Dosage",
      type: "text",
      required: true,
      component: FormComponent.Select,
      helperText: "Specify the amount and unit (e.g., 500mg, 10ml)",
      componentProps: {
        placeholder: "Select dosage",
        options: dosageOptions,
      },
    },
    frequency: {
      label: "Frequency",
      type: "text",
      required: true,
      component: FormComponent.Input,
      helperText:
        "How often the medication should be taken (e.g., twice daily, every 8 hours)",
      componentProps: {
        placeholder: "Enter frequency",
        type: "text",
      },
    },
    route: {
      label: "Route",
      type: "text",
      required: true,
      component: FormComponent.Input,
      helperText:
        "How the medication is administered (e.g., oral, intravenous, topical)",
      componentProps: {
        placeholder: "Enter route of administration",
        type: "text",
      },
    },
    start_date: {
      label: "Start Date",
      type: "date",
      required: true,
      component: FormComponent.DatePicker,
      helperText: "Select a future date for medication start",
      componentProps: {
        showTime: false,
        format: "YYYY-MM-DD",
      },
      validator: [
        {
          regex: "^\\d{4}-\\d{2}-\\d{2}$",
          message: "The start date field must match the format Y-m-d",
        },
      ],
    },
    end_date: {
      label: "End Date",
      type: "date",
      required: false,
      component: FormComponent.DatePicker,
      helperText: "Select a date after the start date (optional)",
      componentProps: {
        showTime: false,
        format: "YYYY-MM-DD",
      },
      validator: [
        {
          regex: "^\\d{4}-\\d{2}-\\d{2}$",
          message: "The end date field must match the format Y-m-d",
        },
      ],
    },
    description: {
      label: "Description",
      type: "text",
      required: false,
      component: FormComponent.Textarea,
      helperText:
        "Provide a brief description of the medication and its purpose",
      componentProps: {
        placeholder: "Enter medication description",
        rows: 4,
      },
    },
    notes: {
      label: "Notes",
      type: "text",
      required: false,
      component: FormComponent.Textarea,
      helperText:
        "Add any special instructions, side effects, or important information",
      componentProps: {
        placeholder: "Enter any additional notes",
        rows: 4,
      },
    },
  },
};
